<template>
    <div id="background"/>
</template>

<script>
    export default {
        name: 'Background',

        mounted() {
            require("particles.js")

            // eslint-disable-next-line no-undef
            particlesJS("background", {
                "particles": {
                    "number": {"value": 30, "density": {"enable": true, "value_area": 400}},
                    "color": {"value": "#c1c2bd"},
                    "shape": {
                        "type": "image",
                        "stroke": {"width": 0, "color": "#000000"},
                        "polygon": {"nb_sides": 5},
                        "image": {"src": "assets/star.png", "width": 50, "height": 50}
                    },
                    "opacity": {
                        "value": 1,
                        "random": true,
                        "anim": {"enable": true, "speed": 1, "opacity_min": 0, "sync": false}
                    },
                    "size": {
                        "value": 150,
                        "random": true,
                        "anim": {"enable": true, "speed": 1, "size_min":50, "sync": false}
                    },
                    "line_linked": {"enable": false},
                    "move": {
                        "enable": true,
                        "speed": 1,
                        "direction": "none",
                        "random": true,
                        "straight": false,
                        "out_mode": "out",
                        "bounce": false,
                        "attract": {"enable": true, "rotateX": 600, "rotateY": 600}
                    }
                },
                "interactivity": {
                    "detect_on": "window",
                    "events": {
                        "onhover": {"enable": true, "mode": "bubble"},
                        "onclick": {"enable": true, "mode": "push"},
                        "resize": true
                    },
                    "modes": {
                        "grab": {"distance": 0, "line_linked": {"opacity": 1}},
                        "bubble": {"distance": 250, "size": 10, "duration": 10, "opacity": 0, "speed": 0},
                        "repulse": {"distance": 50, "duration": 5},
                        "push": {"particles_nb": 1},
                        "remove": {"particles_nb": 1}
                    }
                },
                "retina_detect": true
            });
        }
    }
</script>

<style scoped>

    /**
    A z-index of -1 puts this untouchable into the background.
    This thing will also cover the entire website
     */
    #background{
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: #1a1f22;
        z-index: -1;
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }

    /*
    Some settings for the particle.js canvas
     */
    canvas{
        display:block;
        vertical-align:bottom;
        position: absolute;
    }
</style>

